@if (up() || season()) {
  <nav class="crumbs" [class.crumbs--tabbed]="hasTabs()" aria-label="Breadcrumb">
    <!-- Phone: one step up -->
    @if (up(); as parent) {
      <a class="crumbs__up md:hidden" [routerLink]="parent.link">
        <svg class="crumbs__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6" /></svg>
        <span class="crumbs__up-label">{{ parent.label }}</span>
      </a>
    }

    <!-- Desktop: the whole trail -->
    <ol class="crumbs__trail hidden md:flex">
      @for (item of items(); track $index; let last = $last) {
        <li class="crumbs__item">
          @if (last) {
            <span class="crumbs__current" aria-current="page">{{ item.label }}</span>
          } @else if (item.link) {
            <a class="crumbs__link" [routerLink]="item.link">{{ item.label }}</a>
          } @else {
            <span class="crumbs__text">{{ item.label }}</span>
          }
          @if (!last) {
            <span class="crumbs__sep" aria-hidden="true">›</span>
          }
        </li>
      }
    </ol>

    <!-- Desktop: the season the whole page is scoped to, at the end of the row. It used to sit
         under the entity name in the top bar (CC, 04/10/2026: keep the crest and name clean).
         On a phone the same control is at the end of the section-tab row instead. -->
    @if (season(); as sn) {
      <label class="crumbs__season">
        <span class="crumbs__season-label">Season</span>
        <select class="crumbs__season-select" (change)="onSeasonChange(sn, $event)">
          @for (s of sn.options; track s) {
            <option [value]="s" [selected]="sn.selected === s">{{ s }}</option>
          }
        </select>
      </label>
    }
  </nav>
}
